/**
 * @fileoverview View selector tabs for filtering domains
 * @module TechStackAnalysis/components/ViewSelector
 */

import React from 'react';
import { Layers, Shield, Cloud, Database, Network } from 'lucide-react';

// View options configuration
const VIEW_OPTIONS = [
  { id: 'full-stack', label: 'Full Stack', icon: Layers },
  { id: 'security', label: 'Security', icon: Shield },
  { id: 'cloud', label: 'Cloud', icon: Cloud },
  { id: 'data', label: 'Data', icon: Database },
  { id: 'network', label: 'Network', icon: Network }
];

/**
 * View selector tabs component
 * @param {Object} props
 * @param {string} props.activeView - Currently active view ID
 * @param {Function} props.onViewChange - View change handler
 * @param {Function} props.onHaptic - Haptic feedback trigger
 */
const ViewSelector = ({ activeView, onViewChange, onHaptic }) => {
  const handleClick = (viewId) => {
    onHaptic?.();
    onViewChange?.(viewId);
  };

  return (
    <div className="ts-view-selector" role="tablist" aria-label="Stack view filter">
      {VIEW_OPTIONS.map(view => {
        const Icon = view.icon;
        return (
          <button
            key={view.id}
            className={`ts-view-tab ${activeView === view.id ? 'active' : ''}`}
            onClick={() => handleClick(view.id)}
            role="tab"
            aria-selected={activeView === view.id}
            aria-controls={`panel-${view.id}`}
          >
            <Icon size={16} />
            <span>{view.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewSelector;
export { VIEW_OPTIONS };
